<template>


    <b-modal class="modal fade" ref="rideshare-modal" centered size="md" scrollable style="padding: 10px">

        <template v-slot:modal-header>
            <slot name="header">
                <h6 class="modal-title">RideShare Referral</h6>





            </slot>
            <slot name="close-button">
                <button type="button" class="close" @click="closeModal" data-dismiss="modal" aria-label="Close">
                    <span>×</span>
                </button>
            </slot>
        </template>

        <div style="width: 100%; margin-bottom: 20px;">

            Sorry, we're unable to quote online for rideshare or hire vehicles. We will pass this onto Transport
            Protect who specialise as Rideshare insurance experts & they will contact you shortly.

            <!-- <b-row>

                <b-col class="less-padding">
                    <base-input label="Vehicle Type" name="Vehicle Type"
                        inputGroupClasses="uBind-input">
                        <el-select v-model="selectedItem.vehicle.vehicleType">
                            <el-option v-for="option in vehicleTypeOptions" :key="option.label" :label="option.label"
                                :value="option.value">
                            </el-option>
                        </el-select>
                    </base-input>
                </b-col>
            </b-row> -->

            <!-- <b-row>
                <b-col class="less-padding">
                    <base-input label="Freight Task" name="Freight Task"
                        inputGroupClasses="uBind-input">
                        <el-select v-model="selectedItem.vehicle.freightTask">
                            <el-option v-for="option in freightTaskOptions" :key="option.label" :label="option.label"
                                :value="option.value">
                            </el-option>
                        </el-select>
                    </base-input>
                </b-col>
            </b-row>

            <b-row>




                <b-col class="less-padding">
                    <base-input label="Registration" v-model="selectedItem.vehicle.motorwebGlasses.registration"
                        inputGroupClasses="uBind-input" />

                </b-col>




                <b-col class="less-padding">
                    <base-input label="VIN" v-model="selectedItem.vehicle.motorwebGlasses.vin"
                        inputGroupClasses="uBind-input" />

                </b-col>


                <b-col class="less-padding">
                    <base-input label="Post Code" v-model="selectedItem.vehicle.vehiclePostcode"
                        inputGroupClasses="uBind-input" />

                </b-col>
            </b-row>

            <b-row>
                <b-col class="less-padding">
                    <base-input label="Make" v-if="selectedItem.vehicle.vehicleType != 'SE1'"
                        v-model="selectedItem.vehicle.motorwebGlasses.make" inputGroupClasses="uBind-input" />

                    <base-input label="Make" v-if="selectedItem.vehicle.vehicleType == 'SE1'" name="Make"
                         inputGroupClasses="uBind-input">
                        <el-select @change="selectedItem.vehicle.motorwebGlasses.family = ''"
                            v-model="selectedItem.vehicle.motorwebGlasses.make">
                            <el-option v-for="option in carModels" :key="option.Make" :label="option.Make"
                                :value="option.Make">
                            </el-option>
                        </el-select></base-input>

                </b-col>

                <b-col class="less-padding">


                    <base-input label="Family" v-if="selectedItem.vehicle.vehicleType == 'SE1'" name="Family"
                         inputGroupClasses="uBind-input">
                        <el-select v-model="selectedItem.vehicle.motorwebGlasses.family">
                            <el-option
                                v-for="option in (carModels.find(f => f.Make == selectedItem.vehicle.motorwebGlasses.make) ? carModels.find(f => f.Make == selectedItem.vehicle.motorwebGlasses.make).Models : [])"
                                :key="option" :label="option" :value="option">
                            </el-option>
                        </el-select></base-input>



                    <base-input label="Family" v-if="selectedItem.vehicle.vehicleType != 'SE1'"
                        v-model="selectedItem.vehicle.motorwebGlasses.family" inputGroupClasses="uBind-input" />


                </b-col>

                <b-col class="less-padding">
                    <base-input label="Vehicle Year" v-model="selectedItem.vehicle.vehicleYear"
                        inputGroupClasses="uBind-input" />

                </b-col>



            </b-row>

            <b-row>
                <b-col class="less-padding">
                    <base-input label="Sum Insured" v-model="selectedItem.vehicle.sumInsured"
                        inputGroupClasses="uBind-input" />

                </b-col>
            </b-row> -->





        </div>

        <template v-slot:modal-footer>
            <b-button icon @click="closeModal()">Ok</b-button>
        </template>

    </b-modal>

</template>

<script>
//import MotorContinueQuote from "../../components/MotorContinueQuote.vue";
import BaseInput from "../../../components/Inputs/BaseInput.vue";
import { Select, Option } from "element-ui";
import VueMultiselectComponent from 'vue-multiselect-component'
import { entsiaDropDowns } from "../../../assets/data/entsiaLOVs";

export default {
    name: "RideshareModal",
    //policy_id: "",
    //selectedCustomerId: 0,
    // props: {
    //     vehicleEditMode: {
    //         type: String
    //     },
    //     //selectedItem: null 
    //     _selectedItem: {
    //         type: Object
    //     },
    // },
    data() {
        return {
            //value: [],
            vehicleEditMode: 'add',
            selectedItem: null,
            selectedIdx: null,
            freightTaskOptions: entsiaDropDowns.freightTaskOptions,
            vehicleTypeOptions: entsiaDropDowns.vehicleTypeOptions,
        }
    },
    methods: {

        closeModal() {
            this.$refs['rideshare-modal'].hide();
        },
        openModal() {
            this.$refs['rideshare-modal'].show();
        },
    },
    components: {
        BaseInput,
        [Select.name]: Select,
        [Option.name]: Option,
        //Spinner,
        //FileUpload,
        VueMultiselectComponent
    },
    async mounted() {
        //console.log("c13");
        //this.$refs['vehicle-modal'].show();

        //console.log(this._selectedItem);
        //this.selectedItem = this._selectedItem;
    }
};
</script>
